import { ApiCustomer } from '@vend/types'
import { trimContactInfo } from '../../../../react/modals/common/customer-contact-utils'

export const trimCustomerInfo = (customer: ApiCustomer) => {
  customer.first_name = customer.first_name?.trim() || ''
  customer.last_name = customer.last_name?.trim() || ''
  trimContactInfo(customer)
}

export const isContactInfoUpdated = (
  customer: ApiCustomer,
  originalCustomer: ApiCustomer
) => {
  return (
    customer.first_name?.trim() !== originalCustomer.first_name?.trim() ||
    customer.last_name?.trim() !== originalCustomer.last_name?.trim() ||
    customer.email?.trim() !== originalCustomer.email?.trim() ||
    customer.mobile?.trim() !== originalCustomer.mobile?.trim() ||
    customer.phone?.trim() !== originalCustomer.phone?.trim() ||
    customer.fax?.trim() !== originalCustomer.fax?.trim()
  )
}

export const isMissingName = (customer: ApiCustomer) => {
  return (
    (!customer.first_name || customer.first_name.trim().length === 0) &&
    (!customer.last_name || customer.last_name.trim().length === 0)
  )
}

export const isMissingContactInfo = (customer: ApiCustomer) => {
  return (
    (!customer.email || customer.email.trim().length === 0) &&
    (!customer.mobile || customer.mobile.trim().length === 0) &&
    (!customer.phone || customer.phone.trim().length === 0) &&
    (!customer.fax || customer.fax.trim().length === 0)
  )
}
